import { Console } from "@utils/console";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import autobind from "autobind-decorator";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Container } from "react-bootstrap";
import VisibilitySensor from "react-visibility-sensor";

interface Props {
	id?: string;
	className?: string;
	bgClassName?: string;
	bgColor?: string;
	size?: "sm" | "lg" | "null";
	sendEvent?: boolean;
	as?: React.ElementType;
}

interface State {
	wasVisible: boolean;
}

export class LandingContainer extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props);

		this.state = { wasVisible: false };
	}

	public render(): ReactNode {
		const { sendEvent } = this.props;
		const { wasVisible } = this.state;

		if (sendEvent) {
			return (
				<VisibilitySensor
					{...GoogleAnalytics4.getVisibilitySensorProps()}
					active={!wasVisible}
					onChange={this.onVisibilityChange}
				>
					{this.renderContainer()}
				</VisibilitySensor>
			);
		}

		return this.renderContainer();
	}

	public renderContainer(): ReactNode {
		const { id, className, bgClassName, bgColor, size, children, as = undefined } = this.props;
		const sizeClass = this.getClassBySize(size);

		if (bgClassName) {
			return (
				<div id={id} className={bgClassName} style={{ backgroundColor: bgColor }}>
					<Container className={compact([className, sizeClass]).join(" ")}>{children}</Container>
				</div>
			);
		}

		return (
			<Container as={as} id={id} className={compact([className, sizeClass]).join(" ")}>
				{children}
			</Container>
		);
	}

	@autobind
	protected onVisibilityChange(isVisible: boolean): void {
		if (isVisible) {
			const { id } = this.props;

			if (id) {
				GoogleAnalytics4.sendEvent("BM_blockImpression", {
					blockName: id,
				});
			} else {
				Console.warn("LandingContainer: It wants to send event but the container doesn't have id.");
			}

			this.setState({
				wasVisible: true,
			});
		}
	}

	protected getClassBySize(size: "lg" | "sm" | "null" | undefined): string {
		switch (size) {
			case "lg":
				return "py-4 py-sm-5";
			case "sm":
				return "py-2 py-sm-3";
			case "null":
				return "";
			default:
				return "py-3 py-sm-4";
		}
	}
}
